import '../scss/app.scss';

import * as events from './events.js';
import * as utils from './utils';
import * as data from './data';
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(MorphSVGPlugin, DrawSVGPlugin, ScrollTrigger);
gsap.registerPlugin(MorphSVGPlugin, DrawSVGPlugin);

// Load the full build.
// var _ = require('lodash');


function wrapTextInSpans(element, className = '') {
    const nodes = Array.from(element.childNodes); // Obtenir tous les enfants directs
    const fragment = document.createDocumentFragment(); // Créer un fragment pour reconstruire le contenu

    nodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
            // Traiter chaque segment de texte
            node.textContent.trim().split(/\s+/).forEach((word, index, array) => {
                const span = document.createElement('span'); // Créer un span pour chaque mot
                if (className) {
                    span.classList.add(className); // Ajouter une classe si spécifiée
                }
                span.textContent = word;
                fragment.appendChild(span);
                
                // Ajouter un espace après chaque mot sauf le dernier
                if (index < array.length - 1) {
                    fragment.appendChild(document.createTextNode(' '));
                }
            });
        } else {
            // Pour les éléments HTML et les nœuds de texte vides, les ajouter tels quels
            // Rajouter les espaces après seulement si c'est une lettre donc vérifier l'élément d'après
            fragment.appendChild(document.createTextNode(' '));
            fragment.appendChild(node.cloneNode(true));
            fragment.appendChild(document.createTextNode(' '));
        }
    });

    // Remplacer le contenu de l'élément par le nouveau fragment
    element.innerHTML = '';
    element.appendChild(fragment);
}


// Fonction pour décomposer les textes en spans
const initPresentation = () => {
    document.querySelectorAll('.decompose').forEach(element => {
        let newHTML = document.createDocumentFragment();

        function decomposeElement(node, parent) {
            if (node.nodeType === Node.TEXT_NODE) {
                // Divise le texte en parties basées sur des espaces, en préservant les espaces
                let parts = node.textContent.match(/[^\s]+|\s+/g);
                parts.forEach(part => {
                    let span;
                    if (part.trim()) { // Si la partie est un mot
                        span = document.createElement('span');
                        span.className = 'decomposed';
                        span.textContent = part;
                        span.style.transform = `scale(${utils.getRandomNumber(1.3, 2)}) translate(${utils.getRandomNumber(-1000, 1000)}%, ${utils.getRandomNumber(-1000, 1000)}%)`;
                        parent.appendChild(span);
                    } else { // Si la partie est un espace
                        parent.appendChild(document.createTextNode(part));
                    }
                });
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                // Si c'est un élément HTML, le clone, traite ses enfants récursivement
                const clone = node.cloneNode(false); // Clone sans enfants
                Array.from(node.childNodes).forEach(child => decomposeElement(child, clone));
                parent.appendChild(clone);
            }
        }

        // Décompose récursivement à partir de l'élément parent
        Array.from(element.childNodes).forEach(child => decomposeElement(child, newHTML));
        
        element.innerHTML = ''; // Nettoie le contenu initial
        element.appendChild(newHTML); // Ajoute le nouveau contenu décomposé
    });

    // gsap.set('.decomposed', { scale: 1.2 });

    data.timelines.presentation = gsap.timeline({
        paused: true, 
        onComplete: () => {
            // Ca ne marche pas, voir pourquoi
            gsap.set('.decomposed', { clearProps: 'transform' });
            gsap.to('.decomposed', {
                duration: 1, 
                // translate: '0% 0%',
                x: '0%', 
                y: '0%', 
            });
        },
        // scrollTrigger: {
        //     trigger: '.paper-section',
        //     scroller: '.paper-section', // spécifier le conteneur de défilement
        //     pin: true, // épingler l'élément déclencheur lorsqu'il est actif
        //     start: 'top top', // lorsque le haut de l'élément déclencheur atteint le haut de la fenêtre
        //     end: '+=500', // fin après avoir défilé de 500px au-delà du début
        //     scrub: 1, // défilement fluide, prend 1 seconde pour "rattraper" la barre de défilement
        //     snap: {
        //         snapTo: 'labels', // s'accrocher à l'étiquette la plus proche dans la timeline
        //         duration: { min: 0.2, max: 3 }, // la durée de l'animation de l'accroche doit être d'au moins 0.2 secondes, mais pas plus de 3 secondes (déterminée par la vélocité)
        //         delay: 0.2, // attendre 0.2 secondes après le dernier événement de défilement avant de faire l'accroche
        //         ease: 'power1.inOut' // l'assouplissement de l'animation de l'accroche ("power3" par défaut)
        //     }
        // }
    })
    data.timelines.presentation.to('.middle-part', {
        duration: 1,
        height : '425px',
    });
    data.timelines.presentation.to('.bottom-part', {
        duration: 1,
        height: '30px',
        // rotateX : '1800deg',
    }, '-=1');
    data.timelines.presentation.to('.decomposed', {
        duration: 0.1,
        scale: 1,
        x: '0%',
        y: '0%',
        opacity: 1,
        stagger: 0.05,
    }, '-=1.2');
   
}

// Fonction pour décomposer les textes en spans
let userGuessID = {};
const coupta    = utils.genererCalcul();
const initDevis = () => {
    wrapTextInSpans(document.getElementById('devisTextIntro'), '');
    wrapTextInSpans(document.getElementById('devisTextForm'), 'form-part');

    document.querySelectorAll('.goto-devis-form').forEach(elem => {
        elem.addEventListener('click', () => {
            if (elem.classList.contains('red')) {
                document.getElementById('gender').options[0].selected = true;
                document.getElementById('name').innerHTML = 'votre nom';
                document.getElementById('email').innerHTML = 'votre email';
                document.getElementById('phone').innerHTML = 'votre numéro';
                document.getElementById('raison').innerHTML = 'détaillez votre demande';
            }

            data.timelines.devis.part_2.play();
        });
    });

    userGuessID.gender    = utils.getRandomNumber(0, 2, 2);
    userGuessID.lastname  = utils.chooseRandomName(data.lastnames);
    userGuessID.firstname = userGuessID.gender == 1 ? utils.chooseRandomName(data.firstnameMen) : utils.chooseRandomName(data.firstnameWomen);
    userGuessID.email     = `${userGuessID.lastname.toLowerCase()}.${userGuessID.firstname.toLowerCase()}@gmail.com`;
    userGuessID.phone     = utils.generatePhoneNumber();
    userGuessID.raison    = utils.chooseRandomName(data.raisons);

    document.getElementById('gender').options[userGuessID.gender].selected = true;
    document.getElementById('name').innerHTML = `${userGuessID.firstname} ${userGuessID.lastname}`
    document.getElementById('email').innerHTML = `${userGuessID.email}`;
    document.getElementById('phone').innerHTML = `${userGuessID.phone}`;
    document.getElementById('raison').innerHTML = `${userGuessID.raison}`;

    document.getElementById('equation').innerHTML = coupta.question;

    data.timelines.devis = {
        part_1 : gsap.timeline({paused: true, onComplete : () => {
                // document.getElementById('devisIntro').style.display = 'none';
            }}).to('#devisIntro span', {
                duration: 0.2,
                opacity: 1,
                stagger: 0.1,
            }),
        part_2 : gsap.timeline({paused: true, onComplete : () => {
                document.getElementById('devisIntro').style.display = 'none';
            }}).to('#devisIntro', {
                duration: 0.2,
                opacity: 0,
            }).to('#devisForm', {
                duration: 0.2,
                opacity: 1,
            }).to('#devisForm .form-part', {
                duration: 0.2,
                opacity: 1,
                stagger: 0.2,
            })
    }
    // }).to('#devisIntro span', {
    //     duration: 0.25,
    //     opacity: 0,
    //     stagger: 0.15,
    // }).to('#devisForm', {
    //     duration: 0.2,
    //     opacity: 1,
    // }).to('#devisForm .form-part', {
    //     duration: 0.5,
    //     opacity: 1,
    //     stagger: 0.5,
    // });
}

/** Définition des positions et constantes */
const setLetterYPos = (i) => {
    i = typeof i !== 'undefined' ? i : 0;

    const svgLoader     = document.getElementById('loader');
    const headerHeight  = document.getElementById('header').offsetHeight;
    const taglineHeight = document.getElementById('taglineTop').offsetHeight;
    const letterHeight  = (svgLoader.getBoundingClientRect().height / 150) * 100;
    const ratio         = 150 / svgLoader.getBoundingClientRect().height;
    const y             = -((((window.innerHeight / 2) - ((headerHeight / 2) + letterHeight + taglineHeight)) * ratio) - i);

    return y;
};

let positions = {};
const setPositions = () => {
    const letterYPos = setLetterYPos();

    positions = {
        letters : {
            k : {
                y : letterYPos,
                x : -45,
            },
            r : {
                y : letterYPos,
                x : 40,
            },
            i : {
                y : setLetterYPos(12),
                x : 125,
                top_wand : {
                    y : letterYPos,
                    x : 125,
                },
                bottom_wand : {
                    y : setLetterYPos(90),
                    x : 125,
                }
            },
            s_0 : {
                y : letterYPos,
                x : 150,
            },
            s_1 : {
                y : letterYPos,
                x : 175,
            }
        } 
    };
}

const positionningLabel = 'positionning';

const initPage = () => {
    setPositions();

    const svgLoader     = document.getElementById('loader');
    const circleLoader  = document.getElementsByClassName('circle-loader');
    const trails        = document.getElementsByClassName('trail');

    /** On affiche le loader */
    /** A modifier pour gérer ça en css pour qu'il s'affiche quand même au départ */
    document.getElementById('backgroundContainer').style.opacity = 1;

    // On init les timeslines des sections
    initPresentation();
    initDevis();
    
    // On enregitre les plugins dont on se servira
    // gsap.registerPlugin(MorphSVGPlugin, DrawSVGPlugin, ScrollTrigger);

    MorphSVGPlugin.convertToPath("circle, rect, polygon");

    // Masquage de tous les chemins en réglant leur tracé sur 0%
    gsap.set(circleLoader, {drawSVG: "0%"});

    // Initialisation de la timeline principale
    data.timelines.main = gsap.timeline({
        onReverseComplete : () => {
            data.statements.animation_running = false;

            document.querySelectorAll('.invisible-circle').forEach(function(element) {
                element.style.left      = 0;
                element.style.top       = 0;
                element.style.width     = 0;
                element.style.height    = 0;
            });

            if (data.statements.section_active) {
                const activeNavBar  = document.querySelector('.navbar-list.active');
                const targetSection = document.querySelector(activeNavBar.getAttribute('data-target-section'));

                // data.timelines.loader_as_home = gsap.timeline({paused: true})
                //     .addLabel(positionningLabel)
                //     .to('.circle-loader', {
                //         fill: activeNavBar.getAttribute('data-color'),
                //         morphSVG: (index, elem) => {
                //             return `#${elem.getAttribute('id')}_Section`
                //         }
                //     }, positionningLabel)
                //     .to('#loader', {
                //         y: (index, elem) => {
                //             return -(window.innerHeight / 2) + (elem.getBoundingClientRect().height * 0.3);
                //         }, 
                //         scale: 0.4,
                //     }, positionningLabel)
                
                // data.timelines.loader_as_home.play();
                targetSection.animation.play();
        }
    }, onComplete : () => {
        /* L'animation est terminée et ce n'est pas une section */
        data.statements.animation_running    = false;
        data.statements.section_active       = false;

        const letterK       = document.getElementById('letterK');
        const letterKTop    = letterK.getBoundingClientRect().top - document.getElementById('taglineTop').offsetHeight;
        const letterKBottom = letterK.getBoundingClientRect().bottom;

        gsap.set(data.ids.taglineTop, {top: letterKTop});
        gsap.to(data.ids.taglineTop, {duration: 0.3, ease: "sine.inOut", opacity: 1, skewX: '0deg'});
        gsap.set(data.ids.taglineBottom, {top: letterKBottom});
        gsap.to(data.ids.taglineBottom, {duration: 0.4, ease: "sine.inOut", opacity: 1, skewX: '0deg'}, '-=0.7');

        document.querySelectorAll('.invisible-circle').forEach(element => {
            element.classList.remove('inactive');

            const targetSelector    = element.getAttribute('data-target');
            const target            = document.querySelector(targetSelector);
            if (target) {
                const targetBCR         = target.getBoundingClientRect();
                element.style.left      = `${targetBCR.left}px`;
                element.style.top       = `${targetBCR.top}px`;
                element.style.width     = `${targetBCR.width}px`;
                element.style.height    = `${targetBCR.height}px`;
            }
        });
    }});

    // On fait tourner en dessinant les cercles du loader par ces bordures et un remplissage noir
    data.timelines.main.addLabel(positionningLabel);
    const ease  = 0.35;

    for (let i = 0; i < circleLoader.length; i++) {
        const x     = Math.round(utils.getRandomNumber(0, 1)) == 0 ? -window.innerWidth : window.innerWidth;
        const y     = Math.round(utils.getRandomNumber(0, 1)) == 0 ? utils.getRandomNumber(-window.innerHeight, 0) : utils.getRandomNumber(0, window.innerHeight);
        const color = circleLoader[i].getAttribute('data-color');

        let leader = {
            x : x,
            y : y,
        }

        data.timelines.main.set(circleLoader[i], {
            x: x,
            y: y,
        }, `${positionningLabel}+=0`)
        .to(circleLoader[i], {
            attr: { cx: 0, cy: 0 },
            onUpdate: () => {
                leader.x = gsap.getProperty(circleLoader[i], "x");
                leader.y = gsap.getProperty(circleLoader[i], "y");
        
                // leader.x = gsap.getProperty(this.targets()[0], "x");
                // leader.y = gsap.getProperty(this.targets()[0], "y");
            },
            duration: 1.5, 
            x: 0,
            y: 0,
        }, `${positionningLabel}+=0`)

        leader.x = gsap.getProperty(circleLoader[i], "x");
        leader.y = gsap.getProperty(circleLoader[i], "y");
        
        // let j = 25;
        // while (j--) {
        //     let trail = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        //     svgLoader.appendChild(trail);

        //     let alpha = (j + 1) / 25;

        //     data.timelines.main.set(trail, {
        //         x: leader.x,
        //         y: leader.y,
        //         alpha: alpha,
        //         stroke: color,
        //         strokeWidth: 5,
        //     }, `${positionningLabel}+=0`);
    

        //     let posTrail = {
        //         x : gsap.getProperty(trail, 'x'),
        //         y : gsap.getProperty(trail, 'y'),
        //     };

        //     data.timelines.main.to(trail, {
        //         x: "+=1",       // Change x (nécessaire pour activer les modificateurs)
        //         y: "+=1",       // Change y (nécessaire pour activer les modificateurs)
        //         duration: 1.5,
        //         modifiers: {
        //             x: function(x) {        
        //                 x = posTrail.x + (leader.x - posTrail.x) * ease;
        //                 trail.setAttribute("x2", leader.x - x);
        //                 return x;
        //             },
        //             y: function(y) {        
        //                 y = posTrail.y + (leader.y - posTrail.y) * ease;
        //                 trail.setAttribute("y2", leader.y - y);
        //                 return y;
        //             }
        //         }
        //     }, `${positionningLabel}+=0`);
        // }
    }
   
    data.timelines.main
        .to(svgLoader, {
            duration: 2, 
            rotate: 720, 
            ease: 'power1.out'
        }, `${positionningLabel}+=0`)
        .to(circleLoader, {
            duration: 3, 
            drawSVG: "100%", 
            ease: 'power1.out', 
            stagger: 0.1
        }, `${positionningLabel}-=0.3`)
        .to(circleLoader, {
            duration: 3, 
            fill : (index, elem) => {
                // if (elem.getAttribute('id').indexOf('circleMenu')  !== -1) {
                    return elem.getAttribute('data-color');
                // } else {
                    // return '#000000';
                // }
            },
            ease: 'power1.out', 
            stagger: 0.1
        }, `${positionningLabel}+=0.5`);

    // On anime les lettres du logo
    data.timelines.main
        .to('#letterK', {duration: 0.5, ease: "power1.in", x: positions.letters.k.x, y: positions.letters.k.y}, `${positionningLabel}+=1.5`)
        .to('#letterK', {duration: 0.5, ease: "power1.in", morphSVG: "#logoLetterK", opacity: 1}, `${positionningLabel}+=1.7`)
        .to('#letterR', {duration: 0.3, ease: "power1.in", x: positions.letters.r.x, y: positions.letters.r.y}, `${positionningLabel}+=1.9`)
        .to('#letterR', {duration: 0.3, ease: "power1.in", morphSVG: "#logoLetterR", opacity: 1}, `${positionningLabel}+=2.0`)
        .to('#letterI', {duration: 0.4, ease: "power1.in", x: positions.letters.i.x, y: positions.letters.i.y}, `${positionningLabel}+=2.1`)
        .to('#letterI', {duration: 0.4, ease: "power1.in", morphSVG: "#logoLetterI", opacity: 1}, `${positionningLabel}+=2.3`)
        .to('#letterS', {duration: 0.5, ease: "power1.in", x: positions.letters.s_0.x, y: positions.letters.s_0.y}, `${positionningLabel}+=2.5`)
        .to('#letterS', {duration: 0.5, ease: "power1.in", morphSVG: "#logoLetterS", opacity: 1}, `${positionningLabel}+=2.7`)
        .to('#letterS2', {duration: 0.3, ease: "power1.in", x: positions.letters.s_1.x, y: positions.letters.s_1.y}, `${positionningLabel}+=2.9`)
        .to('#letterS2', {duration: 0.3, ease: "power1.in", morphSVG: "#logoLetterS2", opacity: 1}, `${positionningLabel}+=3.1`)
        .to("#wandTop", {duration: 0.5, ease: "power1.in", x: positions.letters.i.top_wand.x, y: positions.letters.i.top_wand.y}, `${positionningLabel}+=3.3`)
        .to("#wandTop", {duration: 0.8, ease: "bounce", morphSVG: "#logoWandTop", opacity: 1}, `${positionningLabel}+=3.5`)
        .to("#wandBottom", {duration: 0.5, ease: "power1.in", x: positions.letters.i.bottom_wand.x, y : positions.letters.i.bottom_wand.y}, `${positionningLabel}+=3.5`)
        .to("#wandBottom", {duration: 0.8, ease: "bounce", morphSVG: "#logoWandBottom", opacity: 1}, `${positionningLabel}+=3.7`);

    // On anime les icones qui deviennent des boutons pour chacune des sections du site
    // y ou x 150 car c'est la taille d'origine de la viewbox et de la forme
    data.timelines.main
        .to('#circleMenuDevis', {duration: 0.4, x: 0, y: 150}, `${positionningLabel}+=3.1`)
        .to('#circleMenuDevis', {duration: 0.4, morphSVG: {shape: "#menuDevis", type: "rotational", origin: "-42% 43%, 23% 67%", shapeIndex: 10, map: "complexity"}, opacity: 1}, `${positionningLabel}+=3.3`)
        .to('#circleMenuGallery', {duration: 0.4, x: 150, y: 0}, `${positionningLabel}+=3.2`)
        .to('#circleMenuGallery', {duration: 0.4, morphSVG: {shape: "#menuGallery", type: "rotational", origin: "-82% 143%, 43% 27%", shapeIndex: 10, map: "complexity"}, opacity: 1}, `${positionningLabel}+=3.5`)
        .to('#circleMenuPrestations', {duration: 0.4, x: -150, y: 0}, `${positionningLabel}+=3.4`)
        .to('#circleMenuPrestations', {duration: 0.4, morphSVG: {shape: "#menuPrestations", type: "rotational", origin: "-12% 113%, 23% 47%", shapeIndex: 10, map: "complexity"}, opacity: 1}, `${positionningLabel}+=3.7`)
        .to('#circleMenuPresentation', {duration: 0.4, x: 0, y: -150}, `${positionningLabel}+=3.6`)
        .to('#circleMenuPresentation', {duration: 0.4, morphSVG: {shape: "#menuPresentation", type: "rotational", origin: "-122% 73%, 93% 17%", shapeIndex: 10, map: "complexity"}, opacity: 1}, `${positionningLabel}+=3.9`)
        .to("#buttonMenu", {duration: 0.3, opacity: 1, scale: 1, ease: 'power1.out'}, `${positionningLabel}+=3.5`)
        .to(".certificate img", {duration: 0.3, opacity: 1, x: 0, ease: 'power2.inOut'}, `${positionningLabel}+=3.7`)
        // data.timelines.mininav = gsap.timeline({paused : true});
    // data.timelines.mininav.to('#mininav', {duration: 0.4, scale: 1, x: 0}, `${positionningLabel}+=4.4`)
    
    // On crée la timeline et l'animation du footer et du header
    data.timelines.header = gsap.timeline({onComplete : () => {
        // document.getElementById('navBarStartPathHome').animation.play();
    }});
    data.timelines.header.addLabel(positionningLabel)
        .to("footer, header, .header-bis", {duration: 0.3, y: 0}, `${positionningLabel}+=3.7`)
        .to(".navbar-list", {duration: 0.3, scale: 1, stagger: 0.1}, `${positionningLabel}+=3.9`)
        .to(".header-bis", {duration: 0.3, scaleX: 1}, `${positionningLabel}+=4.1`)
        .to("#navBarStartPathHome", {morphSVG: {shape: '#navBarMiddlePathHome'}}, `${positionningLabel}+=4.3`)
        .to("#navBarStartPathDevis", {fill : document.getElementById('navBarListDevis').getAttribute('data-color'), morphSVG: {shape: '#navBarMiddlePathDevis'}}, `${positionningLabel}+=4.4`)
        .to("#navBarStartPathPrestations", {fill : document.getElementById('navBarListPrestations').getAttribute('data-color'), morphSVG: {shape: '#navBarMiddlePathPrestations'}}, `${positionningLabel}+=4.5`)
        .to("#navBarStartPathPresentation", {fill : document.getElementById('navBarListPresentation').getAttribute('data-color'), morphSVG: {shape: '#navBarMiddlePathPresentation'}}, `${positionningLabel}+=4.7`)
        .to("#navBarStartPathGallery", {fill : document.getElementById('navBarListGallery').getAttribute('data-color')}, `${positionningLabel}+=4.8`)

    addTimelineToMenuElement();
    addTimelineToNavbarElement();
    addTimelineToSectionElement();

    playTimelines();
}

// On joue les timeline
const playTimelines = (timescale) => {
    timescale = typeof timescale === 'undefined' ? 1 : timescale;

    data.timelines.main.timeScale(timescale).play();
    data.timelines.header.timeScale(timescale).play();
    // data.timelines.mininav.timeScale(timescale).play();
}

const playTimelinesReverse = (timescale) => {
    timescale = typeof timescale === 'undefined' ? 1 : timescale;

    data.timelines.main.timeScale(timescale).reverse();
    data.timelines.header.timeScale(timescale).play();
}

// On ajoute une timelime à chaque bouton de section pour créer une animation au survol
const addTimelineToMenuElement = () => {
    document.querySelectorAll('.shape').forEach(elem => {
        const tl = gsap.timeline({paused: true});
        tl.set(elem, {transformOrigin: '50% 50%'});
        tl.to(elem, {
            duration: 0.3,
            morphSVG: elem.getAttribute('data-path-morph-id'),
            fill: elem.getAttribute('data-color')
        });

        elem.animation = tl; // Stocker l'animation GSAP directement dans l'élément pour un accès facile
    });
}

// On ajoute une animation pour le survol des éléments de la navbar
const addTimelineToNavbarElement = () => {
    document.querySelectorAll('.navbar-list').forEach(elem => {
        const id = elem.getAttribute('data-path-start-id');
        
        const tl = gsap.timeline({paused: true, onComplete: () => {
            if (data.statements.section_active) {
                data.statements.animation_running = false;
                // gsap.to('.circle-loader', {fill: elem.getAttribute('data-color')})
            }
        }}).addLabel('positionning');
        tl.set(id, {transformOrigin: '50% 50%'})
        .to(id, {duration: 0.3,morphSVG: elem.getAttribute('data-path-elementary-id'), fill: elem.getAttribute('data-color')}, 'positionning')
        .to(elem.getAttribute('data-target-svg-id'), {duration: 0.2, scale: 1.2}, 'positionning')
        .to(elem.querySelector('a'), {duration: 0.2, color: elem.getAttribute('data-color')}, 'positionning');

        document.querySelector(elem.getAttribute('data-path-start-id')).animation = tl; // Stocker l'animation GSAP directement dans l'élément pour un accès facile
    });
}

// Animation d'apparition des sections
const addTimelineToSectionElement = () => {
    document.querySelectorAll('.sub-section').forEach(elem => {
        const id = elem.getAttribute('data-path-start-id');
        const tl = gsap.timeline({paused: true, onComplete: () => {
            if (data.statements.section_active) {
                data.statements.animation_running = false;
            }

            if (document.querySelector('.navbar-list.active').getAttribute('data-target-section') === '#sectionPresentation') {
                data.timelines.presentation.play();
            } else if (document.querySelector('.navbar-list.active').getAttribute('data-target-section') === '#sectionDevis') {
                data.timelines.devis.part_1.play();
            }
        }, onReverseComplete: () => {
            if (data.statements.section_active) {
                const activeNavBar = document.querySelector('.navbar-list.active');

                if (activeNavBar.getAttribute('data-target-section') !== '#sectionHome') {
                    document.querySelector(activeNavBar.getAttribute('data-target-section')).animation.play();
                } else {
                    // data.timelines.main.timeScale(1.5).play();
                    data.timelines.main.play();
                }
            }
        }}).addLabel(positionningLabel);

        // tl.to('#loader', {duration: 0.5, rotate: -720}, positionningLabel)
        tl.to('.section-container', {duration: 0.2, opacity: 1}, positionningLabel)
        .to(elem, {duration: 0.3, opacity: 1, y: 0}, positionningLabel)
        // .to(elem, {duration: 0.2, color: elem.getAttribute('data-color')}, 'positionning');

        elem.animation = tl; // Stocker l'animation GSAP directement dans l'élément pour un accès facile
    });
}

let messageSent = false;
function envoyerFormulaire() {
    if (messageSent) {
        alert('Vous venez d\'envoyer un message, si vous voulez envoyer un nouveau message, rechargez la page.');
        return;
    }
    const gender = document.getElementById('gender').value;
    const name = document.getElementById('name').innerText;
    const email = document.getElementById('email').innerText;
    const phone = document.getElementById('phone').innerText;
    const subject = document.getElementById('subject').value;
    const raison = document.getElementById('raison').innerText;
    const equationResult = parseInt(document.getElementById('equationResult').value);

    // Vérification de l'équation
    if (equationResult !== coupta.reponse) {
        alert('Erreur dans la réponse à l\'équation. Veuillez réessayer.');
        return;
    }

    const data = {
        gender,
        name,
        email,
        phone,
        subject,
        raison
    };

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/', true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                messageSent = true;
                alert('Message envoyé avec succès.');
            } else {
                alert('Erreur lors de l\'envoi de votre message. Veuillez réessayer.');
            }
        }
    };
    xhr.send(JSON.stringify(data));
}

document.getElementById('submitDevis').addEventListener('click', envoyerFormulaire);

window.addEventListener('load', () => {
    initPage();

    events.initEventsNav();
});

// Création d'une animation de repositionnement des lettres 
// JE SUIS KRISS VOTRE MAGICIEN pour que ça s'ajuste avec l'event resize
const repositionLetters = () => {
    setPositions();

    data.timelines.standalone_letter = gsap.timeline({paused : true, onComplete : () => {
        const letterKTop = document.querySelector('#letterK').getBoundingClientRect().top - document.getElementById('taglineTop').offsetHeight;
        gsap.to("#taglineTop", {duration: 0.3, top: letterKTop});

        const letterKBottom = document.querySelector('#letterK').getBoundingClientRect().bottom;
        gsap.to("#taglineBottom", {duration: 0.3, top: letterKBottom});
    }}).addLabel('positionning');
    
    data.timelines.standalone_letter
        .to("#letterK", {duration : 0.1, x: positions.letters.k.x, y: positions.letters.k.y, morphSVG: "#logoLetterK"}, 'positionning+=0.1')
        .to("#letterR", {duration : 0.15, x: positions.letters.r.x, y: positions.letters.r.y, morphSVG: "#logoLetterR"}, 'positionning+=0.2')
        .to("#letterI", {duration : 0.1, x: positions.letters.i.x, y: positions.letters.i.y, morphSVG: "#logoLetterI"}, 'positionning+=0.3')
        .to("#letterS", {duration : 0.15, x: positions.letters.s_0.x, y: positions.letters.s_0.y, morphSVG: "#logoLetterS"}, 'positionning+=0.15')
        .to("#letterS2", {duration : 0.1, x: positions.letters.s_1.x, y: positions.letters.s_1.y, morphSVG: "#logoLetterS2"}, 'positionning+=0.4')
        .to("#wandTop", {duration: 0.15, x: positions.letters.i.top_wand.x, y: positions.letters.i.top_wand.y, morphSVG: "#logoWandTop"}, 'positionning+=0.25')
        .to("#wandBottom", {duration: 0.1, x: positions.letters.i.bottom_wand.x, y : positions.letters.i.bottom_wand.y, morphSVG: "#logoWandBottom"}, 'positionning+=0.35');

    data.timelines.standalone_letter.play();
}

window.addEventListener('resize', utils.debounce(() => {
    repositionLetters();

    /** Repositionning circle menu clone **/
    document.querySelectorAll('.invisible-circle').forEach(element => {
        element.classList.remove('inactive');

        const targetSelector    = element.getAttribute('data-target');
        const target            = document.querySelector(targetSelector);
        if (target) {
            const targetBCR         = target.getBoundingClientRect();
            element.style.left      = `${targetBCR.left}px`;
            element.style.top       = `${targetBCR.top}px`;
            element.style.width     = `${targetBCR.width}px`;
            element.style.height    = `${targetBCR.height}px`;
        }
    });
}));